import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=6ca6b04e&scoped=true"
import script from "./xiangqing.vue?vue&type=script&lang=js"
export * from "./xiangqing.vue?vue&type=script&lang=js"
import style0 from "./xiangqing.vue?vue&type=style&index=0&id=6ca6b04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6b04e",
  null
  
)

export default component.exports